import { render, staticRenderFns } from "./ErrorEventNotificationViewPage.vue?vue&type=template&id=063f882c&scoped=true&"
import script from "./ErrorEventNotificationViewPage.vue?vue&type=script&lang=ts&"
export * from "./ErrorEventNotificationViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorEventNotificationViewPage.vue?vue&type=style&index=0&id=063f882c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f882c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable,VTextField})
